import styled from 'styled-components'

import { BreadcrumbsStyled } from '@webapp/core/components/Breadcrumbs/styles/BreadcrumbsStyled'

interface IPageTopContainerStyledProps {}

export const PageTopContainerStyled = styled.div<IPageTopContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  z-index: 1;
  position: relative;

  ${BreadcrumbsStyled} {
    margin: 0;
  }
`
